export default __webpack_public_path__ + "static/media/varlyq.79421587.png";